import { Container, Typography } from "@mui/material";

function Dashboard() {
  return (
    <Container sx={(theme) => ({ paddingY: theme.spacing(3) })}>
      <Typography variant="overline" tag="p" gutterBottom>
        Coming Soon
      </Typography>
      <Typography variant="h4" tag="div">
        Personal Assistant
      </Typography>
    </Container>
  );
}

export default Dashboard;
